import type { EchoSubmitEndDetail, EchoSubmitStartDetail } from '../types';

type Submitter = HTMLElement | null | undefined;
type FormField = HTMLInputElement | HTMLButtonElement | HTMLTextAreaElement;

export function isEchoForm(form: HTMLFormElement): boolean {
  return (
    form.hasAttribute('data-echo') &&
    form.getAttribute('data-echo') !== 'false' &&
    form.getAttribute('data-remote') !== 'true'
  );
}

export function getFormMethod(form: HTMLFormElement, submitter: Submitter): string {
  return (submitter?.getAttribute('formmethod') ?? form.getAttribute('method') ?? 'GET').toUpperCase();
}

export function getFormAction(form: HTMLFormElement, submitter: Submitter): string {
  return submitter?.getAttribute('formaction') ?? form.getAttribute('action') ?? window.location.href;
}

export function startSubmit(form: HTMLFormElement, detail: EchoSubmitStartDetail): void {
  form.dispatchEvent(new CustomEvent<EchoSubmitStartDetail>('echo:submit-start', { bubbles: true, detail }));
}

export function endSubmit(form: HTMLFormElement, detail: EchoSubmitEndDetail): void {
  form.dispatchEvent(new CustomEvent<EchoSubmitEndDetail>('echo:submit-end', { bubbles: true, detail }));
}

export function disableForm(form: HTMLFormElement): void {
  const elements = form.querySelectorAll<FormField>(`
    input[data-disable-with]:enabled,
    button[data-disable-with]:enabled,
    textarea[data-disable-with]:enabled,
    input[data-disable]:enabled,
    button[data-disable]:enabled,
    textarea[data-disable]:enabled
  `);

  Array.from(elements).forEach(element => {
    const disableWith = element.getAttribute('data-disable-with');

    if (disableWith && element instanceof HTMLButtonElement) {
      element.textContent = disableWith;
    } else if (disableWith) {
      element.value = disableWith;
    }

    element.disabled = true;
  });
}
